import { FaTimes, FaChevronRight } from 'react-icons/fa';
import CallerIcon from '../../styles/img/reports/caller.svg';
import { FEEDBACK_OPTIONS } from '../../constants/feedbackConstants';

const FeedbackOptionsScreen = ({ onClose, onOptionSelect, isVisible }) => {
  return (
    <div className={`transition-transform duration-500 ease-[cubic-bezier(0.16,1,0.3,1)] ${
      isVisible ? 'translate-x-0' : '-translate-x-full'
    }`}>
      <button
        type="button"
        onClick={onClose}
        onKeyDown={(e) => e.key === 'Enter' && onClose()}
        className="absolute top-4 right-6 w-8 h-8 flex items-center justify-center text-gray-400 transition-colors duration-200 z-10"
      >
        <FaTimes className="w-5 h-5" />
      </button>

      <div className="p-8 pt-12">
        <div className="flex justify-center">
          <div className="w-32 h-32 rounded-2xl flex items-center justify-center">
            <img src={CallerIcon} alt="caller" className="w-32 h-32" />
          </div>
        </div>

        <h2 className="geomanistMedium text-[18px] font-bold text-center text-gray-900 mb-4">
          Donner mon avis
        </h2>

        <p className="text-center geomanistbold text-[14px] font-bold text-gray-600 mb-14">
          Aidez PikkoPay à améliorer votre expérience.
        </p>

        <div className="flex justify-center mb-8">
          <div className="w-full h-[1px] bg-blue-200" />
        </div>

        <div className="space-y-4 my-10">
          {FEEDBACK_OPTIONS.map((option, index) => (
            <button
              type="button"
              key={option.id}
              onClick={() => onOptionSelect(option)}
              onKeyDown={(e) => e.key === 'Enter' && onOptionSelect(option)}
              className="w-full flex items-start justify-between p-4 h-32 transition-all duration-200 group"
              style={{
                borderBottom: index === 0 ? '0.5px solid #00000030' : 'none',
              }}
            >
              <div className="flex items-start justify-start w-full">
                <div
                  className="w-12 h-12 rounded-xl flex items-start justify-center mr-6 flex-shrink-0"
                  style={{ backgroundColor: option.backgroundColor }}
                >
                  <img src={option.icon} alt={option.title} className="w-10 h-10" />
                </div>

                <div className="flex flex-col text-left gap-1">
                  <span className="geomanistMedium font-light text-gray-800 text-2xl mb-1">
                    {option.title}
                  </span>
                  <p className="text-gray-600 geomanistRegular leading-relaxed text-lg mr-4">
                    {option.description}
                  </p>
                </div>
              </div>

              <FaChevronRight className="text-gray-400 fill-gray-400 transition-colors duration-200 flex-shrink-0" />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FeedbackOptionsScreen; 